import {Rule} from '@rc-component/form/lib/interface';

export const nameRules: Rule[] = [{required: true, message: 'Введите имя'}];

export const emailRules: Rule[] = [
	{required: true, message: 'Введите email'},
	{type: 'email', message: 'Некорректный email'},
];

export const passwordRules: Rule[] = [
	{required: true, message: 'Введите пароль'},
	{min: 6, message: 'Минимум 6 символов'},
];

export const confirmPasswordRules: Rule[] = [
	{required: true, message: 'Подтвердите пароль'},
	({getFieldValue}) => ({
		validator(_, value) {
			if (!value || getFieldValue('password') === value) {
				return Promise.resolve();
			}

			return Promise.reject(new Error('Пароли не совпадают'));
		},
	}),
];
